/* eslint-disable react-hooks/exhaustive-deps */
import AppContext from "AppContext";
import React, { useContext, useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import { getEnvVar } from "utils/env";
import Page from "components/common_components/Page/Page";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { stableSort } from "components/common_components/Tables/sortComparators";
import Notification from "./Notification";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 30px",
        fontSize: "large",
        marginBottom: 20,
        marginTop: 30,
    },
    title: {
        fontSize: "large",
    },
    linearProgress: {
        width: 50,
        marginLeft: 5,
    },
}));

export const useNotifications = (caller, unsb = true) => {
    const { subscribeToNotifications } = useContext(AppContext);
    const [notifications, setNotifications] = useState({});

    useEffect(() => {
        const subscription = subscribeToNotifications(caller, setNotifications);
        return () => subscription.unsubscribe();
    }, []);

    return notifications;
};

function Notifications() {
    const classes = useStyles();
    const identityToNotify = getEnvVar("VITE_CHAT_IDENTITY");
    const notifications = useNotifications("notifications");
    const [_notifications, _setNotifications] = useState([]);
    const {
        api: {
            Chat: { Notifications },
        },
        markCachedNotificationsAsRead,
    } = useContext(AppContext);

    useEffect(() => {
        if (identityToNotify && notifications) {
            _setNotifications(notifications[identityToNotify]);
        }

        return () => {
            _setNotifications([]);
        };
    }, [notifications]);

    const markNotificationAsRead = async (id) => {
        // Mark notification as read
        await Notifications.markNotificationsAsRead([id]);
        // Clear notifications
        markCachedNotificationsAsRead(identityToNotify, [id]);
    };

    return (
        <Page className={classes.root}>
            <Paper>
                <div className={classes.header}>
                    <div className={classes.title}>Notifications</div>
                </div>
                {hasElements(_notifications) &&
                    stableSort(_notifications, "desc", "id").map((notification) => {
                        const { id } = notification;
                        return <Notification key={id} notification={notification} onMarkAsRead={markNotificationAsRead} />;
                    })}
            </Paper>
        </Page>
    );
}

export default Notifications;
